const sourcesToBeSkipped = ['STORYBOOK', 'STARLORD', 'AMBEV']

export const skipMultiUserSelection = (source) => {
  return sourcesToBeSkipped.includes(source)
}
